module.exports = __webpack_public_path__ + "img/about2.efe219b8.png";